import React, { useState, useEffect } from "react";
import { autoFormatEnergyValue } from "@solarschools/component-lib/src/utilities/EnergyUnits";

const MapControls = ({
  schools,
  isFullScreen,
  setFullScreen,
  setSelectedSchool
}) => {
  const [searchIsOpen, setSearchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);

  const filteredSchools = () => {
    const schls = schools.filter(s => {
      if (s.organisationSiteCount > 1) {
        return (s.organisationName + " " + s.siteName)
          .toLowerCase()
          .startsWith(searchTerm.toLowerCase());
      } else {
        return s.organisationName
          .toLowerCase()
          .startsWith(searchTerm.toLowerCase());
      }
    });
    setResults(schls);
  };

  useEffect(() => {
    if (searchTerm.length > 0) {
      filteredSchools();
    }
  }, [searchTerm]);

  return (
    <div
      className="position-absolute layer-overlay m-2 d-flex flex-row-reverse align-items-center justify-content-end"
      style={{ right: 0 }}
    >
      <div
        className="bg-dark opacity-faded rounded-circle border-0 p-2 material-icons text-white m-1"
        style={{ cursor: "pointer" }}
        onClick={() => setFullScreen(!isFullScreen)}
      >
        {isFullScreen ? "fullscreen_exit" : "fullscreen"}
      </div>
      <div
        className={`bg-dark opacity-faded border-0 p-2 m-1 ${
          searchIsOpen ? "" : "rounded-circle"
        } d-flex flex-row-reverse align-items-center`}
        style={{ lineHeight: 1, borderRadius: "50px 50px" }}
      >
        <span
          style={{ cursor: "pointer" }}
          onClick={() => setSearchOpen(!searchIsOpen)}
          className="material-icons text-white"
        >
          {searchIsOpen ? "close" : "search"}
        </span>
        {searchIsOpen ? (
          <input
            value={searchTerm}
            onChange={({ target: { value } }) => setSearchTerm(value)}
            className="bg-transparent text-white border-0 mx-2"
            type="text"
            placeholder="Search for your school"
          />
        ) : null}
      </div>
      {searchIsOpen && searchTerm.length ? (
        <div className="position-absolute mt-5 fixed-top bg-white">
          {results &&
            results.slice(0, 5).map((school, i) => (
              <div
                key={i}
                className="p-3"
                style={{ cursor: "pointer" }}
                onClick={() => setSelectedSchool(school)}
              >
                <p className="paragraph-small mb-0">{school.resourceName}
                </p>
                {school.peakSolarCapacity ? (
                  <p className="mb-0 paragraph-tiny">
                    {autoFormatEnergyValue(school.peakSolarCapacity)} Solar
                    Capacity
                  </p>
                ) : null}
              </div>
            ))}
        </div>
      ) : null}
    </div>
  );
};

export default MapControls;



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolMap/MapControls.js